module.exports = __webpack_public_path__ + "img/Magnuss50.499f625b.jpg";